// extracted by mini-css-extract-plugin
export default {"toggle":"NWWfwe6FInzbO9yM9t98"};